<template>

  <div class="row menu_container">

    <div class="entity_menu_bx" v-if="showIntroductionTab" @click="navigateToIntroduction">
      <div class="ic_container">
        <span class="ic ic-home3"></span>
      </div>
      <div class="title">{{introductionTabLabel}}</div>
    </div>

    <div class="entity_menu_bx" v-if="showProgramsTab" @click="navigateToPrograms">
      <div class="ic_container">
        <span class="ic ic-degreeProgram"></span>
      </div>
      <div class="title">{{programsTabLabel}}</div>
    </div>

    <div class="entity_menu_bx" v-if="showRelatedCareersTab" @click="navigateToRelatedCareers">
      <div class="ic_container">
        <span class="ic ic-degreeProgram"></span>
      </div>
      <div class="title">{{relatedCareersLabel}}</div>
    </div>

    <div class="entity_menu_bx" v-if="showStreamsTab" @click="navigateToPathways">
      <div class="ic_container">
        <span class="ic ic-stream"></span>
      </div>
      <div class="title">{{streamsTabLabel}}</div>
    </div>

    <div class="entity_menu_bx" v-if="showAlumniInsightsTab" @click="navigateToAlumniInsights">
      <div class="ic_container">
        <span class="ic ic-alumniInsights"></span>
      </div>
      <div class="title">{{alumniInsightsTabLabel}}</div>
    </div>

  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'

export default {
  name: 'career-menu',
  props: ['code', 'isComingFromBookmark'],
  methods: {
    navigateToIntroduction () {
      return this.$router.push({name: 'careerDetail', params: {code: this.code, isComingFromBookmark: this.isComingFromBookmark}})
    },
    navigateToPrograms () {
      return this.$router.push({name: 'careerPrograms', params: {code: this.code, isComingFromBookmark: this.isComingFromBookmark}})
    },
    navigateToRelatedCareers () {
      return this.$router.push({name: 'relatedCareers', params: {code: this.code, isComingFromBookmark: this.isComingFromBookmark}})
    },
    navigateToPathways () {
      return this.$router.push({name: 'careerPathways', params: {code: this.code, isComingFromBookmark: this.isComingFromBookmark}})
    },
    navigateToAlumniInsights () {
      return this.$router.push({name: 'careerAlumniInsights', params: {code: this.code, isComingFromBookmark: this.isComingFromBookmark}})
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    }
  },
  computed: {
    ...mapState({
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'packages': state => state.dashboard.packages
    }),
    exploreCareerDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_CAREER_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showIntroductionTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.introductionTab) {
        return false
      }
      return exploreCareerDetailFlagMap.introductionTab.enabled
    },
    introductionTabLabel () {
      const defaultLabel = 'Introduction'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.introductionTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.introductionTab.label || defaultLabel
    },
    showProgramsTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.programsTab) {
        return false
      }
      return exploreCareerDetailFlagMap.programsTab.enabled
    },
    programsTabLabel () {
      const defaultLabel = 'Programs'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.programsTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.programsTab.label || defaultLabel
    },
    showRelatedCareersTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.relatedCareersTab) {
        return false
      }
      return exploreCareerDetailFlagMap.relatedCareersTab.enabled
    },
    relatedCareersLabel () {
      const defaultLabel = 'Related Careers'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.relatedCareersTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.relatedCareersTab.label || defaultLabel
    },
    showStreamsTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.streamsTab) {
        return false
      }
      return exploreCareerDetailFlagMap.streamsTab.enabled
    },
    streamsTabLabel () {
      const defaultLabel = 'Pathways'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.streamsTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.streamsTab.label || defaultLabel
    },
    showAlumniInsightsTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.alumniInsightsTab) {
        return false
      }
      return exploreCareerDetailFlagMap.alumniInsightsTab.enabled
    },
    alumniInsightsTabLabel () {
      const defaultLabel = 'Alumni Insights'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.alumniInsightsTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.alumniInsightsTab.label || defaultLabel
    }
  }

}
</script>

<style scoped>
  .top-border {
    border-top: 3px solid #fff;
  }

  .right-border {
    border-right: 3px solid #fff;
  }
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerMenu.vue